import { datadogLogs } from '@datadog/browser-logs';
import { MonitoringService } from '@inflearn/monitoring';
import { useEffect } from 'react';
import { NEXT_PUBLIC_ENV } from '../../../appConfig';
import useClientAccountProfileQuery from '../../queries/useClientAccountProfileQuery';

export function Monitoring() {
  const { data: profile } = useClientAccountProfileQuery();

  useEffect(
    function setData() {
      if (NEXT_PUBLIC_ENV === 'localhost') {
        return;
      }

      const monitoringService = MonitoringService.getInstance();

      if (profile) {
        monitoringService.setUser({
          name: profile.name,
          id: profile.id,
          isAdmin: profile.isAdmin,
          isB2bGroupManager: !!profile.managedGroup?.id,
          isB2bMember: !!profile.group?.id,
        });
        datadogLogs.setUser({
          name: profile.name,
          id: profile.id.toString(),
          isAdmin: profile.isAdmin,
          isB2bGroupManager: !!profile.managedGroup?.id,
          isB2bMember: !!profile.group?.id,
        });
      }

      monitoringService.setDatadogSessionId();
    },
    [profile],
  );

  return <></>;
}
